<template>
  <div>
    <v-row class="mt-1">
      <v-col cols="12" md="8">
        <h1 class="text-left mx-4 mt-2">Payslip Settings</h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card class="mx-2">
          <v-form v-model="payslipSettingsForm" :readonly="readonlyForm">
            <v-row class="my-1">
              <v-col cols="12">
                <h3 class="text-left mx-5">Payslip Number</h3>
              </v-col>
            </v-row>

            <v-row id="payslip-number">
              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  label="Prefix"
                  maxlength="20"

                  v-model="payslipSettings.prefix"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  label="Auto-incrementing Value"
                  type="number"
                  min="0"
                  :rules="[rules.requiredOr0, rules.notEmptyNumber]"
                  v-model="payslipSettings.value"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" sm="4">
                <v-text-field
                  outlined
                  dense
                  class="mx-3 rounded-input"
                  maxlength="20"
                  label="Suffix"
                  v-model="payslipSettings.suffix"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="mb-2">
              <v-col cols="12" md="4" sm="8" id="next-payslip-number">
                <div class="mx-5 font-weight-medium text-left">
                  Next Payslip Number:
                  <span class="font-weight-bold">
                    {{ payslipSettings.prefix
                    }}{{ Number(payslipSettings.value) + 1
                    }}{{ payslipSettings.suffix }}
                  </span>
                </div>
              </v-col>
            </v-row>

            <!-- upload img row -->
            <v-row class="mx-2" justify="end">
              <v-col cols="4" sm="6" align-self="center">
                <h3 class="text-left">Font Image</h3>
              </v-col>

              <v-spacer></v-spacer>

              <v-col cols="8" sm="6" class="text-right" align-self="center" v-if="!readonlyForm">
                <input
                  type="file"
                  name="upload"
                  id="upload"
                  @change="fontImageCallback($event)"
                  accept="image/*"
                />
                <label class="new-button mr-3" for="upload" id="upload-image-payslip">
                  Upload Image
                </label>
              </v-col>
            </v-row>

            <!-- row for img preview/institution name -->
            <v-row class="mx-2 mb-2">
              <v-col>
                <div id="preview" v-if="imgUrl">
                  <img :src="imgUrl" alt="Font Image Preview" />
                </div>
                <div v-else-if="payslipSettings.font_image" id="previous">
                  <img :src="payslipSettings.font_image" alt="Stored Image Preview"/>
                </div>
                <div v-else>
                  <h1>
                    {{ currentInstitution.name }}
                  </h1>
                </div>
                <div v-if="!imgUrl">
                  <small>Image apect ratio must be 6:1</small>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="text-left mx-5">Payslip Notes</h3>
                <p class="font-text-medium text-left mx-5 my-1">
                  If entered, these will be displayed on the bottom of the
                  generated payslip.
                </p>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea
                  outlined
                  class="mx-5"
                  placeholder="Payslip Notes"
                  v-model="payslipSettings.notes"
                >
                </v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <h3 class="text-left mx-5">Payslip Options</h3>
              </v-col>
            </v-row>

            <!-- row for data table -->
            <v-row justify="center">
              <v-col cols="8" align-self="center">
                <v-card class="mt-2">
                  <v-data-table
                    :headers="optionHeaders"
                    :items="options"
                    hide-default-footer
                    disable-pagination
                    id="payslip-options"
                  >
                    <template v-slot:item.value="{ item }">
                      <div class="centered-switch">
                        <v-switch inset v-model="payslipSettings[item.value]"> </v-switch>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="text-right mx-4 my-4">
                  <v-btn
                    class="mr-4"
                    color="red"
                    :to="{ name: 'PayrollSettings' }"
                    rounded
                    outlined
                  >
                    Cancel
                  </v-btn>
                  <!-- Removed disabled from submit button :disabled="isLoading || !submitForm" -->
                  <v-btn
                    color="primary"
                    type="submit"
                    rounded
                    @click="savePayslipSettings"
                    :disabled="isLoading || !payslipSettingsForm || readonlyForm"
                  >
                    Submit
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snackbar.visible">
      <span>{{ snackbar.text }}</span>
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from '@utils/misc.js'
import TourHelper from "@utils/tour_helper";


export default {
    name: "PayslipSettings",

    components: {},

    data() {	
        return {
            moment: moment,
            readonlyForm: true,
            rules: {
                required: (v) => !!v || "Required",
                notEmptyNumber:(v) => v >= 0 || "Invalid",
            },
            snackbar: {
                visible: false,
                text: "",
            },
            payslipSettings : {},
            
            payslipSettingsForm: false,
            // fontImage: null,
            imgUrl: null,
            imgfile: null,

            // payslip option headers
            optionHeaders: [
                { text: "Option", value: "option", sortable: false },
                { text: "Enable", value: "value", align:"center"}
            ],

            // dummy payslip options
            options: [
                { option: 'Show Attendance Details', value: 'show_attendance_details' },
                { option: 'Show Bank Details', value: 'show_bank_details' },
                { option: 'Show Payslip Number', value: 'show_payslip_number' },
                { option: 'Show Amount in Words', value: 'show_amount_in_words' },
                { option: 'Show Signature Fields', value: 'show_signature_fields' },
                { option: 'Show Date of Joining', value: 'show_date_of_joining' }
            ],
        }
    },

    computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading", "currentInstitution"]),

    apiEssentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },

    },

    methods: {
        ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Payslip Settings", description: "Add or Edit your Payslip format from this section", videoLink: "https://youtube.com"});
        steps.push({id: '2', description: "Here prefix and suffix will be common for all payslip, auto incrementing value will keep on changing, it keep on adding the value initial set.", el: '#payslip-number'});
        steps.push({id: '3', description: "check your <b>Next</b> payslip number from here.", position:'top' ,el: '#next-payslip-number'});
        steps.push({id: '4', description: "Font Image can be uploaded from here of aspect ratio 6:1:", el: '#upload-image-payslip'});
        steps.push({id: '5', description: "Enable or disable payslip options, which should be shown on payslip", el: '#payslip-options'});
        TourHelper.startTour(this, "payslip__settings", steps);
    },

    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
            if(err.response) {
                console.log(err.response);
            } 
            else {
                this.snackbar.text = "Unknown error occurred";
                this.snackbar.visible = true;
            }
        },

        async getPayslipSettings(){
            this.payslipSettings = await api.call(this.apiEssentials, endpoints.payslipSettings)
        },

        async savePayslipSettings(){
            let post_data = {
                'payslip_settings' : this.payslipSettings,
            }
            if(this.imgfile){
                post_data['font_image'] = this.imgfile
            }
            let response = await api.call(this.apiEssentials, endpoints.payslipSettings, api.Methods.POST, post_data);
            if(response){
                this.$router.push({ name: 'PayrollSettings' })
            }

        },

        async fontImageCallback(e) {
            if(!e.target.files[0])
            return;
            this.imgfile = e.target.files[0]
            let img = new Image()
            img.src = window.URL.createObjectURL(event.target.files[0])
            img.onload = async () => {
              if(img.width == 6 * img.height){
                    this.imgUrl = URL.createObjectURL(this.imgfile)
                    this.imgfile = await Helper.toBase64(this.imgfile);
              } else {
                // alert(`It's ${img.width} x ${img.height} but we require 800 x 600 size image.`);
                this.snackbar.text=`Image aspect ratio must be 6:1`;
                this.snackbar.visible = true;
              }                
          }
    },
  },

  created(){
        this.getPayslipSettings();
        this.handleTour();
        if(this.currentUser.privileges.canEditPayrollPayslipSettings){
          this.readonlyForm = false;
        }
  },

};
</script>

<style scoped>
.centered-switch {
  display: flex;
  justify-content: center;
}

#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}

#previous{
  display: flex;
  justify-content: center;
  align-items: center;
}

#preview img {
  max-width:100%;
  height: auto;
}

#previous img {
  max-width:100%;
  height: auto;
}

#upload {
  display: none;
}

.new-button {
  display: inline-block;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  background-color: #005b53;
  font-size: 0.875rem;
  color: white;
  text-transform: uppercase;
  font-family: inherit;
  font-weight: 500;
  letter-spacing: 0.0892857143em;
  text-indent: 0.0892857143em;
  white-space: nowrap;
}
</style>
